import type { RecipeDef } from '../types';

export const RECIPES: RecipeDef[] = [
  {
    id: 'plank',
    name: { en: 'Plank', pt: 'Tábua' },
    inputs: [{ id: 'wood', amount: 2 }],
    output: { id: 'plank', amount: 1 },
    duration: 2,
    unlockXp: 0,
    phi: 0.8,
    phiClass: 'conservation',
  },
  {
    id: 'ingot',
    name: { en: 'Iron Ingot', pt: 'Lingote' },
    inputs: [
      { id: 'ore', amount: 2 },
      { id: 'wood', amount: 1 },
    ],
    output: { id: 'ingot', amount: 1 },
    duration: 3,
    unlockXp: 6,
    phi: 1.2,
    phiClass: 'conservation',
  },
  {
    id: 'salve',
    name: { en: 'Salve', pt: 'Unguento' },
    inputs: [{ id: 'herb', amount: 2 }],
    output: { id: 'salve', amount: 1 },
    duration: 2,
    unlockXp: 8,
    phi: 1.0,
    phiClass: 'conservation',
  },
  {
    id: 'charm',
    name: { en: 'Bone Charm', pt: 'Amuleto Ósseo' },
    inputs: [
      { id: 'hide', amount: 1 },
      { id: 'herb', amount: 1 },
    ],
    output: { id: 'charm', amount: 1 },
    duration: 4,
    unlockXp: 22,
    phi: 1.6,
    phiClass: 'semantic',
  },
  {
    id: 'shortSword',
    name: { en: 'Short Sword', pt: 'Espada Curta' },
    inputs: [
      { id: 'ingot', amount: 1 },
      { id: 'plank', amount: 1 },
    ],
    output: { id: 'shortSword', amount: 1 },
    duration: 5,
    unlockXp: 30,
    phi: 2.0,
    phiClass: 'identity',
  },
  {
    id: 'cart',
    name: { en: 'Cart', pt: 'Carroça' },
    inputs: [{ id: 'plank', amount: 3 }],
    output: { id: 'cart', amount: 1 },
    duration: 5,
    unlockXp: 18,
    phi: 1.8,
    phiClass: 'conservation',
  },
  {
    id: 'reinforcedCharm',
    name: { en: 'Reinforced Charm', pt: 'Amuleto Reforçado' },
    inputs: [
      { id: 'ingot', amount: 1 },
      { id: 'charm', amount: 1 },
    ],
    output: { id: 'reinforcedCharm', amount: 1 },
    duration: 6,
    unlockXp: 55,
    phi: 2.6,
    phiClass: 'semantic',
  },
  {
    id: 'elixir',
    name: { en: 'Elixir', pt: 'Elixir' },
    inputs: [
      { id: 'salve', amount: 2 },
      { id: 'herb', amount: 1 },
    ],
    output: { id: 'elixir', amount: 1 },
    duration: 5,
    unlockXp: 40,
    phi: 2.2,
    phiClass: 'conservation',
  },
  {
    id: 'anvilPiece',
    name: { en: 'Anvil Piece', pt: 'Peça de Bigorna' },
    inputs: [{ id: 'ingot', amount: 3 }],
    output: { id: 'anvilPiece', amount: 1 },
    duration: 7,
    unlockXp: 70,
    phi: 3.0,
    phiClass: 'conservation',
  },
  {
    id: 'lantern',
    name: { en: 'Lantern', pt: 'Lanterna' },
    inputs: [
      { id: 'ingot', amount: 2 },
      { id: 'crystal', amount: 1 },
    ],
    output: { id: 'lantern', amount: 1 },
    duration: 6,
    unlockXp: 180,
    phi: 3.2,
    phiClass: 'conservation',
  },
  {
    id: 'tome',
    name: { en: 'Tome', pt: 'Tomo' },
    inputs: [
      { id: 'silk', amount: 2 },
      { id: 'bone', amount: 1 },
      { id: 'plank', amount: 1 },
    ],
    output: { id: 'tome', amount: 1 },
    duration: 8,
    unlockXp: 320,
    phi: 4.6,
    phiClass: 'semantic',
  },
  {
    id: 'reliquary',
    name: { en: 'Reliquary', pt: 'Relicário' },
    inputs: [
      { id: 'bone', amount: 4 },
      { id: 'ingot', amount: 2 },
      { id: 'ether', amount: 1 },
    ],
    output: { id: 'reliquary', amount: 1 },
    duration: 12,
    unlockXp: 500,
    phi: 7.2,
    phiClass: 'identity',
  },
  {
    id: 'standard',
    name: { en: 'Royal Standard', pt: 'Estandarte Real' },
    inputs: [
      { id: 'silk', amount: 3 },
      { id: 'ingot', amount: 1 },
      { id: 'plank', amount: 2 },
    ],
    output: { id: 'standard', amount: 1 },
    duration: 14,
    unlockXp: 650,
    phi: 8.8,
    phiClass: 'causal',
  },
  {
    id: 'swordOfFirstCut',
    name: { en: 'Sword of First Cut', pt: 'Espada do Primeiro Corte' },
    inputs: [
      { id: 'ether', amount: 1 },
      { id: 'ingot', amount: 1 },
    ],
    output: { id: 'swordOfFirstCut', amount: 1 },
    duration: 10,
    unlockXp: 60,
    phi: 8.0,
    phiClass: 'identity',
    preserved: true,
  },
];

export function recipeById(id: string): RecipeDef | undefined {
  return RECIPES.find((r) => r.id === id);
}
